import { withIcon } from '@/camo/icons/with-icon'
import ReactComponent from './svg/info-circled.svg'

const InfoCircled = withIcon(ReactComponent, { title: 'InfoCircled' })

export { InfoCircled }
